// What every chart shares: the token names it draws with, the pools' fixed
// colours, and the popover a hover opens.

import type { ReactNode } from "react";

/** Token references for SVG attributes (Recharts takes strings). */
export const CHART = {
  series: "var(--chart-1)",
  plan: "var(--muted-foreground)",
  grid: "var(--emc-grid-line)",
  axis: "var(--emc-separator)",
  cursor: "var(--emc-line-strong)",
  surface: "var(--card)",
  foreground: "var(--foreground)",
  tick: {
    fill: "var(--muted-foreground)",
    fontSize: 11,
    fontFamily: "var(--emc-font)",
  },
} as const;

// tokens.css: --chart-1..5 are the pools RO, PL, HU, GR, KIS, in that fixed
// order, so a pool has the same colour on every chart.
const POOL_ORDER = ["RO", "PL", "HU", "GR", "KIS"] as const;

/** A pool's series colour. A pool the theme does not name takes the next
 * colour by its place in the list it is drawn in. */
export function poolColor(code: string, index = 0): string {
  const fixed = POOL_ORDER.indexOf(code.toUpperCase() as (typeof POOL_ORDER)[number]);
  const slot = fixed >= 0 ? fixed : index % POOL_ORDER.length;
  return `var(--chart-${slot + 1})`;
}

/** The translucent popover a chart opens on hover. */
export function ChartPopover({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <div className="glass flex min-w-44 flex-col gap-1 rounded-inner px-3 py-2.5 text-label text-popover-foreground shadow-pop">
      <p className="m-0 mb-0.5 text-label font-semibold">{title}</p>
      {children}
    </div>
  );
}
